import viewer from '../viewer/index';
export default viewer;



// WEBPACK FOOTER //
// ./src/lib/viewer.js